import './MenuPage.style';

import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { updateMeta } from 'Store/Meta/Meta.action';
import MenuOverlay from 'Component/MenuOverlay';
import Menuq from 'Component/Menuq';
import { HistoryType } from 'Type/Common';
import isMobile from 'Util/Mobile';
import { TOP_NAVIGATION_TYPE } from 'Store/Navigation/Navigation.reducer';
import { MENU } from 'Component/Header/Header.config';
import { changeNavigationState } from 'Store/Navigation/Navigation.action';

export const mapDispatchToProps = dispatch => ({
    updateMeta: meta => dispatch(updateMeta(meta)),
    changeHeaderState: (state) => dispatch(changeNavigationState(TOP_NAVIGATION_TYPE, state))
});

export class MenuPageContainer extends PureComponent {
    static propTypes = {
        updateMeta: PropTypes.func.isRequired,
        history: HistoryType.isRequired
    };

    componentDidMount() {
        const { updateMeta, changeHeaderState } = this.props;
        updateMeta({ title: __('Menu') });
        changeHeaderState({
            name: MENU
        });

        this.redirectIfNotOnMobile();
    }

    redirectIfNotOnMobile() {
        const { history } = this.props;

        if (!isMobile.any()) {
            history.push('/');
        }
    }

    render() {
        return (
            <main block="MenuPage">
                {/* <MenuOverlay /> */}
                <Menuq />
            </main>
        );
    }
}

export default withRouter(connect(null, mapDispatchToProps)(MenuPageContainer));
